module.exports = __webpack_public_path__ + "static/media/NASE_logo.5ffd4d84.png";